<template>
	<svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
		viewBox="0 0 32 32" xml:space="preserve">
		<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8.7,16.9L8.7,16.9c4.8,0.9,9.6,2.3,14.2,4l2.1,0.8L23,23.7c-2.7,2.7-6.9,3.1-10.1,1.1L8.8,22
		C7.1,21,5,20.6,3,21l0,0L8.7,16.9z"/>
		<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8.7,16.9l1.8-5.2c0.4-1.3,1.4-2.3,2.6-2.9l0,0c3.3-1.5,7.1-1,9.9,1.3l0.2,0.2c2,1.6,3,4.2,2.6,6.8L25,22h4
		v-6.3c0-2.3-1-4.6-2.8-6.1l0,0"/>
		<rect x="-360" y="-648" fill="none" width="536" height="680"/>
	</svg>
</template>